import { Challenge, ChallengeStatus } from 'types/graphql';

export const getCurrentChallenge = <T extends Pick<Challenge, 'completed' | 'index' | 'started' | 'status'>>(
  challenges: T[],
) => {
  if (challenges.length === 0) {
    throw new Error('Challenges array cannot be empty in track object');
  }

  return challenges
    .slice()
    .sort((a, b) => a.index - b.index)
    .find(isChallengeActive);
};

export const isChallengeActive = (challenge: Pick<Challenge, 'status' | 'started' | 'completed'>) => {
  const { status } = challenge;

  if (challenge.started > 0 && challenge.completed === 0) {
    return true;
  }

  return [
    ChallengeStatus.Unlocked,
    ChallengeStatus.Creating,
    ChallengeStatus.Created,
    ChallengeStatus.Started,
    ChallengeStatus.Checking,
  ].includes(status);
};

export const getPlayURL = (
  teamSlug: string,
  trackSlug: string,
  currentChallenge?: Pick<Challenge, 'slug' | 'status'>,
  otherChallenges: Pick<Challenge, 'slug'>[] = [],
) => {
  const prefix = `/${teamSlug}/tracks/${trackSlug}/challenges`;
  const lastChallenge = otherChallenges[otherChallenges.length - 1];

  if (currentChallenge) {
    if (currentChallenge.status === 'started') {
      return `${prefix}/${currentChallenge.slug}/assignment`;
    }

    return `${prefix}/${currentChallenge.slug}/notes`;
  }

  return `${prefix}/${lastChallenge.slug}/assignment`;
};
